import BaseSetup from '@/components/BaseSetup';
import { Reactive } from '@/utils/decorators';
import { } from 'vue';

export type TimeTicketWeekCircleEmits = {};
export type TimeTicketWeekCircleProps = {
	color?: string
	value?: number
	label?: string
};

export default class TimeTicketWeekCircleSetup extends BaseSetup {

	static readonly defaultProps = {
		color: 'grey-light',
		value: 0,
	};

	@Reactive private readonly state = {};

	constructor (
		private props: TimeTicketWeekCircleProps,
		private emits: TimeTicketWeekCircleEmits,
	) {
		super();
	}

}
